import React, { createContext, useState, useCallback, useContext } from "react";

const QuotaContext = createContext();

export const QuotaProvider = ({ children }) => {
  const [quota, setQuota] = useState(null);

  const fetchQuota = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/subscriptions/me/quota`, {
        credentials: "include",
      });
      if (res.ok) {
        const data = await res.json();
        setQuota(data);
      }
    } catch (err) {
      console.error("Failed to fetch quota", err);
    }
  }, []); // <- memoized, never changes reference

  return (
    <QuotaContext.Provider value={{ quota, fetchQuota }}>
      {children}
    </QuotaContext.Provider>
  );
};

export const useQuota = () => useContext(QuotaContext);
